<template>
  <el-dialog
    v-drag
    :visible.sync="dialogVisible"
    width="1300px"
    :show-close="true"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="cancel"
  >
    <span slot="title">
      <img
        src="@/assets/images/system/company.png"
      />{{ rowData?.nameCH }}
    </span>
    <div class="content">
      <div class="btn-group">
        <el-input
          v-model="name"
          style="width: 200px"
          size="small"
          placeholder="请输入内容"
          suffix-icon="el-icon-search"
        >
        </el-input>
        <el-select
          v-model="isActived"
          style="width: 200px; margin-left: 10px"
          size="small"
          placeholder="请选择"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <div class="add" @click="dialogVisible2 = true">
          <i
            class="el-icon-circle-plus"
            style="font-size: 20px; vertical-align: middle"
          />
          创建子公司
        </div>
        <div class="add" @click="dialogVisible3 = true">
          <img src="@/assets/images/system/link.png" style="margin-top: 6px" />
          关联子公司
        </div>
      </div>
      <BaseTable
        :height="500"
        :tableData="{
          ...tableData,
          columns,
        }"
        :isPager="false"
        :loading="loading"
      >
        <template slot="companyName" slot-scope="row">
          <p>{{ row.scope.code }}-{{ row.scope.wbName }}</p>
        </template>
        <template slot="yy" slot-scope="row">
          <img src="@/assets/images/system/license.png" class="license" />
          <el-button
            type="text"
            size="mini"
            @click="viewImg(row.scope, 1)"
          >查看</el-button
          >
        </template>
        <template slot="phone" slot-scope="row">
          <p>
            <span class="label"> 手机 </span>
            {{ row.scope.phoneNumber || "--" }}
          </p>
          <p>
            <span class="label"> 邮箱 </span>
            {{ row.scope.email || "--" }}
          </p>
        </template>
        <template slot="status" slot-scope="row">
          <span class="status" :class="`status-${!!row.scope.isActived}`">
            {{ row.scope.isActived ? "启用" : "停用" }}
          </span>
        </template>
        <template slot="opt" slot-scope="row">
          <div class="opt">
            <div class="view-menber" @click="viewMember(row.scope)">
              查看成员
            </div>
            <div class="disassociate" @click="reduceMap(row.scope)">解除关联</div>
            <div style="margin-top: 8px">
              <el-switch
                v-model="row.scope.isActived"
                active-color="#13ce66"
                inactive-color="#ff4949"
                @change="changeIsActived(row.scope)"
              >
              </el-switch>
              {{ row.scope.isActived ? "启用" : "停用" }}
            </div>
          </div>
        </template>
      </BaseTable>
      <ApprovedCompanyDialog
        :dialogVisible="dialogVisible2"
        :editData="{}"
        :subCompanyId="rowData.id"
        :userOptions="userOptions"
        callType="operation"
        @ok="ok"
        @cancel="dialogVisible2 = false"
      ></ApprovedCompanyDialog>
      <LinkSubCompanyDialog
        :dialogVisible="dialogVisible3"
        :rowData="rowData"
        @ok="ok"
        @cancel="dialogVisible3 = false">
      </LinkSubCompanyDialog>
      <ViewMemberDialog
        :dialogVisible="dialogVisible1"
        :rowData="editData"
        @ok="ok"
        @cancel="dialogVisible1 = false">
      </ViewMemberDialog>
    </div>
  </el-dialog>
</template>

<script>
const BaseTable = () => import('@/components/table/BaseTable')
import { getSubCompanyList, enableOrDisableCompany, cancelSubCompanyConnection } from '@/api/system'
import ApprovedCompanyDialog from './ApprovedCompanyDialog'
import LinkSubCompanyDialog from './LinkSubCompanyDialog'
import ViewMemberDialog from './ViewMemberDialog'
export default {
  components: { BaseTable, ApprovedCompanyDialog, LinkSubCompanyDialog, ViewMemberDialog },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: () => {}
    },
    userOptions: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      loading: false,
      tableData: {
        fileds: [
          {
            filed: 'companyName',
            label: '子公司名称',
            width: '',
            isCustom: true
          },
          {
            filed: 'yy',
            label: '营业执照',
            width: '',
            isCustom: true
          },
          {
            filed: 'phone',
            label: '管理员手机/邮箱',
            width: '',
            isCustom: true
          },
          {
            filed: 'status',
            label: '子公司状态',
            width: '',
            isCustom: true
          },
          {
            filed: 'opt',
            label: '操作',
            width: '',
            isCustom: true
          }
        ],
        columns: [],
        total: 0,
        showIndex: true
      },
      options: [
        {
          value: true,
          label: '启用'
        },
        {
          value: false,
          label: '停用'
        }
      ],
      dialogVisible1: false,
      dialogVisible2: false,
      dialogVisible3: false,
      editData: {},
      name: '',
      isActived: true
    }
  },
  computed: {
    columns() {
      const columns = [...this.tableData.columns]
      let arr
      if (this.name) {
        arr = columns.filter((a) => {
          return a.wbName.indexOf(this.name) > -1 && a.isActived === this.isActived
        })
      } else {
        arr = columns.filter((a) => {
          return a.isActived === this.isActived
        })
      }
      return arr
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.getList()
      }
    }
  },
  methods: {
    async getList() {
      try {
        this.loading = true
        const res = await getSubCompanyList({ companyId: this.rowData.id })
        this.loading = false
        if (res.success) {
          this.tableData.columns = res.data
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.log(error)
      }
    },
    viewImg(row) {
      this.$viewerApi({
        images: [`/api/SystemFile/previewFile?fileId=${row.certificateFileId}`]
      })
    },
    changeIsActived(row) {
      const obj = {
        id: row.companyId,
        isActived: row.isActived
      }
      enableOrDisableCompany(obj).then((res) => {
        this.getList()
        if (res.success) {
          this.$message.success(res.errorMessage)
        } else {
          this.$message.error(res.errorMessage)
        }
      })
    },
    viewMember(row) {
      this.editData = row
      this.dialogVisible1 = true
    },
    cancel() {
      this.$refs['form']?.resetFields()
      this.$emit('cancel')
    },
    ok() {
      this.getList()
      this.dialogVisible1 = false
      this.dialogVisible2 = false
      this.dialogVisible3 = false
    },
    reduceMap(row) {
      this.$confirm('此操作将解除关联关系，不删除公司数据，解除后该公司变为独立公司, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        iconClass: 'warning',
        showClose: false,
        closeOnPressEscape: false,
        closeOnClickModal: false,
        customClass: 'w-560',
        center: true
      })
        .then(() => {
          cancelSubCompanyConnection({
            companyId: row.companyId
          }).then((res) => {
            if (res.success) {
              this.$message.success('解除成功')
              this.getList()
            } else {
              this.$message.error(res.errorMessage)
            }
          })
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="less" scoped>
p + p {
  margin-top: 8px;
}
.label {
  width: 64px;
  height: 20px;
  background: #f2f3f5;
  border-radius: 4px 4px 4px 4px;
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 12px;
  color: #666666;
  line-height: 20px;
  text-align: center;
  display: inline-block;
}
.status {
  width: 46px;
  display: inline-block;
  height: 24px;
  background: #ffe6e6;
  border-radius: 4px 4px 4px 4px;
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 10px;
  color: #ca1010;
  line-height: 24px;
  text-align: center;
}
.status-1 {
  background: #ecfff7;
  color: #34c759;
}
.content {
  width: 100%;
}
.btn-group {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
  .add {
    width: 124px;
    height: 32px;
    background: #5753e8;
    border-radius: 100px 100px 100px 100px;
    margin-left: 12px;
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    font-size: 12px;
    color: #ffffff;
    line-height: 32px;
    text-align: center;
    cursor: pointer;
  }
}
.opt {
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  .view-menber {
    width: 80px;
    height: 24px;
    background: #ffffff;
    border-radius: 32px 32px 32px 32px;
    border: 1px solid #5753e8;
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    font-size: 12px;
    color: #5753e8;
    line-height: 24px;
    text-align: center;
    cursor: pointer;
  }
  .disassociate {
    width: 80px;
    height: 24px;
    background: #ffffff;
    border-radius: 32px 32px 32px 32px;
    border: 1px solid #ff7444;
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    font-size: 12px;
    color: #ff7444;
    line-height: 24px;
    text-align: center;
    cursor: pointer;
    margin-top: 8px;
  }
}
/deep/ .el-dialog__body {
  padding-bottom: 0;
}
.footers {
  display: flex;
  justify-content: center;
  margin-top: 40px;
  .cancel {
    width: 120px;
    height: 40px;
    background: #eeeeee;
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    font-size: 14px;
    font-weight: 400;
    color: #999999;
    line-height: 40px;
    text-align: center;
    cursor: pointer;
  }
  .ok {
    width: 120px;
    height: 40px;
    background: rgb(18, 88, 188);
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    font-size: 14px;
    font-weight: 400;
    color: #ffffff;
    line-height: 40px;
    text-align: center;
    margin-left: 20px;
    cursor: pointer;
  }
}
.w-560 {
  width: 560px;
}
</style>
